module.exports = __webpack_public_path__ + "img/dvg-labhoh-logos.97271cda.svg";